<template>
  <div>
    <div class="divSubtitle">
      <p class="subtitle">
        {{ valueText }}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: "Subtitles",
  props: {
    valueText: {
      type: String,
      default: () => {},
    },
  },
};
</script>

<style scoped>
.divSubtitle {
  text-align: center !important;
  display: flex !important;
  margin-bottom: 30px !important;
  margin-top: 0px !important;
}

.subtitle {
  font-size: 20px !important;
  color: #000 !important;
  text-align: left !important;
}
</style>
